<template>
    <div class="loading">
      <div class="loading-container">
        <transition name="fade" appear>
          <div class="loading-wrapper">
            <div class="loading-box">
              <!--如果达到当前进度，就添加灯亮和厂牌亮的样式
                  2) text-item-active
              -->
              <div class="light-container">
                <div class="light"></div>
              </div>
              <ul class="text-list">
                <li>巢</li>
                <li>人</li>
                <li>侦</li>
                <li>探</li>
                <li>社</li>
              </ul>
            </div>
            <div class="loading-progress">{{ progress }}%</div>
          </div>
        </transition>
      </div>
    </div>
</template>

<script>
import statistics from "@/plugins/statistics.js";
export default {
  name: "loading",
  beforeRouteEnter (to, from, next) {
    let url = "https://consumer.fcbox.com/v1/activity/wishIndexInfoFromWechat",
        xhr = new XMLHttpRequest(),
        info = localStorage.getItem("info");
    if(info && JSON.parse(info).avatarUrl) {
      next();
      return;
    } else {
      info = "{}";
    }
    xhr.onreadystatechange = () => {
      if(xhr.readyState === 4) {
        if(xhr.status === 200 || xhr.status === 304) {
          let response = JSON.parse(xhr.responseText);
          if(response.msg === "账号未登录") {
            location.href = response.data;
            return;
          }
          if("data" in response) {
            if(typeof response.data === "object" && 
              "userHeadUrl" in response.data) {
              let infoObj = JSON.parse(info);
              infoObj.avatarUrl = response.data.userHeadUrl;
              localStorage.setItem("info", JSON.stringify(infoObj));
            } 
          }
          next();
        }
      }
    }
    xhr.withCredentials = true;
    xhr.open("GET", url);
    xhr.send(null);
  },
  data () {
    return {
      progress: 0
    }
  },
  methods: {
    addClass (list, num, activeClass) {
      /* 小于等于指定编号的列表添加激活样式
        @lsit: {nodeList}, 元素列表
        @num: {Number}, 指定编号
        @activeClass: {String}, 激活样式
      */
      for(var i=0; i<=num; ++i) {
        if(!list[i].classList.contains(activeClass)) {
          list[i].classList.add(activeClass);
        }
      }
    },
    getPosition (progress) {
      let arr = [20, 40, 60, 80, 99, 120];  // 需要简单的处理一下 100 -> 99
      for(var i=0; i<arr.length-1; ++i) {
        if(progress >= arr[i] && progress <= arr[i+1]) {
          return i;
        }
      }
      return 0;
    }
  },
  mounted () {
    let xhr = new XMLHttpRequest(),
        url = "https://common.fcbox.com/app_manager/activity/detective/static/video.mp4",
        // url = "http://7xvl2z.com1.z0.glb.clouddn.com/nigg2.mp4",
        that = this,
        light = document.querySelector(".light"),
        textList = document.querySelectorAll(".text-list li"),
        arr = [0, 1, 2, 3, 4];
    // 加载完成
    xhr.onreadystatechange = function () {
      if(xhr.readyState === 4) {
        console.log("video loading finished");
        let loading = document.querySelector(".loading-wrapper");
        window.setTimeout( () => {
          loading.classList.add("loading-leave");
        }, 500);
        window.setTimeout( () => {
          that.$router.push("/video");
        }, 2000);    
      }
    }
    // 进度事件
    xhr.onprogress = function (event) {
      if(event.lengthComputable) {
        that.progress = Math.round(event.loaded / event.total * 100);
        light.style.width = `${that.progress}%`;
        let index = that.getPosition(that.progress);

        if(arr.indexOf(index) != -1) {
          that.addClass(textList, index, "text-item-active");
        }
      }
    } 
    xhr.open("GET", url);
    xhr.send(null);
    
    /* 统计数据 */
    statistics(this.$route.query);
  }
}
</script>

<style lang="scss" scoped>
@import "./loading.scss";
</style>



// WEBPACK FOOTER //
// src/pages/loading/loading.vue